module.exports = __webpack_public_path__ + "static/img/patent-swiper-2.c358d77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/patent-swiper-2.png
// module id = 5Vvo
// module chunks = 1